<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <!-- Start Main Loader -->
    <MainLoader key="loader" v-if="false" />
    <!-- End Main Loader -->

    <div key="main" v-else>
      <!-- <main-filter
          :withSearch="false"
          :orderStatuses="orderStatusItems"
          @getResult="setRows"
        /> -->
      <!-- Start Statistics Card-->
      <!-- <div class="row mb-5">
            <div class="wrraper">
              <stats-card
                :title="$t('ordersNum')"
                :number="statisticsItem.number"
              ></stats-card>
            </div>
          </div> -->
      <!-- End Statistics Card-->

      <!-- Start Main Section -->
      <main>
        <v-data-table
          class="thumb strip"
          :headers="headers"
          :items="rows"
          :search="search"
          :custom-filter="helper_filterSearch"
          :loading="loading"
          :loading-text="$t('table.loadingData')"
          item-key="id"
          :items-per-page="paginations.items_per_page"
          hide-default-footer
        >
          <!-- ================== You Can use any slots you want ================== -->
          <!-- Select no data State -->
          <template v-slot:no-data>
            {{ $t("table.noData") }}
          </template>

          <template v-slot:[`item.index`]="{ index }">
            {{ index + 1 }}
          </template>
          <!-- <template v-slot:[`item.client`]="{ item }">
                <div class="d-flex flex-column">
                  <img
                    :src="item.client.avatar"
                    :alt="item.client.fullname"
                    width="50"
                    height="50"
                    class="rounded-circle"
                    @click="show_model_1"
                  />
                  <span>{{ item.client.fullname }}</span>
                </div>
              </template>-->

          <template v-slot:[`item.client`]="{ item }">
            <div v-if="item.client">
              <router-link :to="`/client/show/${item.client.id}`">
                <img class="image" :src="item.client.avatar" alt="" />
                <div>{{ item.client.full_name }}</div>
              </router-link>
            </div>
            <span v-else> لا يوجد </span>
          </template>
          <template v-slot:[`item.phone_sender`]="{ item }">
            <div v-if="item.phone_sender">
              {{ item.phone_sender_code + item.phone_sender }}
            </div>
            <span v-else> لا يوجد </span>
          </template>
          <template v-slot:[`item.phone_receiver`]="{ item }">
            <div v-if="item.phone_receiver">
              {{ item.phone_receiver_code + item.phone_receiver }}
            </div>
            <span v-else> لا يوجد </span>
          </template>
          <template v-slot:[`item.resturant`]="{ item }">
            <div v-if="item.resturant">
              <router-link :to="`/store/show/${item.resturant.id}`">
                <img class="image" :src="item.resturant.icon" alt="" />
                <div>{{ item.resturant.name }}</div>
              </router-link>
            </div>
            <span v-else> لا يوجد </span>
          </template>
          <template v-slot:[`item.delivery_type`]="{ item }">
            <div v-if="item.delivery_type">
              {{ item.delivery_type == "google_restaurant" ? "جوجل" : "زوز" }}
            </div>
            <span v-else> لا يوجد </span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <!-- <span
                  v-if="
                    item.status == 'admin_rejected' ||
                    item.status == 'admin_cancel' ||
                    item.status == 'client_cancel'
                  "
                  class="status canceled"
                >
                  {{ item.status_trans }}
                </span>
                <span
                  v-if="
                    item.status == 'admin_shipping' || item.status == 'pending'
                  "
                  class="status pending"
                >
                  {{ item.status_trans }}
                </span>
                <span
                  v-if="
                    item.status == 'admin_delivered' ||
                    item.status == 'admin_accept'
                  "
                  class="status success"
                >
                  {{ item.status_trans }}
                </span> -->
            <div class="action">
              <div>
                <span
                  v-if="
                    item.status == 'driver_rejected' ||
                    item.status == 'client_cancel' ||
                    item.status == 'driver_cancel' ||
                    item.status == 'admin_cancel'
                  "
                  class="status canceled"
                >
                  {{ item.status_trans }}
                </span>
                <span v-else class="status success">
                  {{ item.status_trans }}
                </span>
                <!-- <span v-else class="status success">
                    {{ item.status_trans }}
                  </span> -->
              </div>
            </div>
          </template>
          <!-- <template v-slot:[`item.order_details.delivery_date`]="{ item }">
                <span>
                  {{
                    item.order_details.delivery_date
                      ? item.order_details.delivery_date
                      : "لا يوجد"
                  }}
                </span>
              </template> -->
          <!-- <template v-slot:[`item.order_details.delivery_timing`]="{ item }">
                <span>
                  {{
                    item.order_details.delivery_date
                      ? item.order_details.delivery_date
                      : "لا يوجد"
                  }}
                </span>
              </template> -->
          <!-- <template v-slot:[`item.to`]="{ item }">
                <router-link :to="`/users/show/${item.to.id}`">
                  {{ item.to.fullname }}
                </router-link>
              </template> -->
          <!-- End:: Users Routes -->

          <!-- Start:: Report Reason Modal Button -->
          <template v-slot:[`item.report_reason`]="{ item }">
            <v-icon
              class="show"
              small
              @click="controlReportReasonModalModal(item.report_reason)"
              v-if="item.report_reason"
            >
              fal fa-eye
            </v-icon>

            <span v-else>_</span>
          </template>
          <!-- End:: Report Reason Modal Button -->

          <!-- Select actions-->
          <template v-slot:[`item.actions`]="{ item }">
            <div class="_actions">
              <v-icon class="show" small @click="showItem(item)">
                fal fa-eye
              </v-icon>
              <!-- <v-icon class="edit" small @click="editItem(item)">
                    fal fa-edit
                  </v-icon> -->
              <!-- <v-icon class="delete" small @click="deleteItem(item)">
                    fal fa-trash
                  </v-icon> -->
            </div>
          </template>

          <!-- ======================== Start Top Section ======================== -->
          <template v-slot:top>
            <!-- <h3 class="title table-title">
                عدد الطلبات {{ statisticsItem.number }}
              </h3> -->
            <!-- Delete dialog -->
            <v-dialog v-model="dialogDelete" max-width="500px">
              <v-card>
                <v-card-title class="text-h5 justify-center">
                  {{ $t("table.deletedialog.areYouSure") }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#1B5E20" @click="deleteItemConfirm">
                    {{ $t("table.deletedialog.ok") }}
                  </v-btn>
                  <v-btn color="#F44336" @click="dialogDelete = false">
                    {{ $t("table.deletedialog.cancel") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Start:: Text Content Modal -->
            <TextContentModal
              @toggleModal="controlReportReasonModalModal"
              :modalIsActive="reportReasonModalIsOpen"
              :title="$t('reportReason')"
              :textContent="reportReasonToShow"
            />
            <!-- End:: Text Content Modal -->
          </template>
          <!-- ======================== End Top Section ======================== -->
        </v-data-table>
      </main>
      <!-- End Main Section -->

      <!-- Start Pagination -->
      <template>
        <div
          class="pagination_container text-center mb-5 d-flex justify-content-end"
        >
          <div class="select-pagination d-flex">
            <span class="first">{{ $t('show') }}</span>
            <v-select
              :items="[10, 25, 50, 100]"
              v-model="paginations.items_per_page"
              @change="onPerPageChange"
            ></v-select>
            <span>{{ $t('entries') }}</span>
          </div>

          <v-pagination
            v-model.number="paginations.current_page"
            :length="paginations.last_page"
            :total-visible="5"
            @input="fetchData($event)"
          ></v-pagination>
        </div>
      </template>
      <!-- End Pagination -->
    </div>
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";

// End:: Importing Modals

export default {
  props: ["userInfo"],
  name: "UsersReports",

  components: {
    TextContentModal,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.orders.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      // ========== Your Data
      rows: [], // injected in created
      drivers: [],

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 2,
        items_per_page: 20,
      },

      // ========== Loading
      loading: false,
      companies: [],
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
            width: "80",
          },
          {
            text: "العميل",
            align: "center",
            value: "client",
            sortable: false,
          },
          {
            text: "رقم الطلب",
            align: "center",
            value: "order_number",
            sortable: false,
          },
          {
            text: "هاتف الراسل",
            align: "center",
            value: "phone_sender",
            sortable: false,
          },
          {
            text: "هاتف المستقبل",
            align: "center",
            value: "phone_receiver",
            sortable: false,
          },
          {
            text: "الحالة",
            align: "center",
            value: `status`,
            sortable: false,
            width: "200",
            padding: "2",
          },

          {
            text: "تاريخ الإنشاء",
            align: "center",
            value: "created_at",
            sortable: false,
          },
          {
            text: "السعر الإجمالي",
            align: "center",
            value: "total_price",
            sortable: false,
          },
          {
            text: "التحكم",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "Reporter",
            align: "center",
            value: "from",
            sortable: false,
          },
          {
            text: "Reported",
            align: "center",
            value: "to",
            sortable: false,
          },
          {
            text: "Report Reason",
            align: "center",
            value: "report_reason",
            sortable: false,
          },
          {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: "center",
          },
        ];
      }
    },
    orderStatusItems() {
      return [
        {
          text: "الطلبات الجديدة",
          value: "pending",
        },
        { text: "المقبولة من السائق", value: "driver_accept" },
        {
          text: "المرفوضة من السائق",
          value: "driver_rejected",
        },
        {
          text: "بدأت  من السائق",
          value: "driver_start_order",
        },
        {
          text: "الطلب أوشك علي الانتهاء",
          value: "driver_pre_finished",
        },
        {
          text: "تم توصيل الطلب",
          value: "driver_finished_package",
        },
        {
          text: "ملغية من قبل العميل",
          value: "client_cancel",
        },
      ];
    },
    delivery_types() {
      return [
        { text: "زوز", value: "zoz_restaurant" },
        { text: "جوجل", value: "google_restaurant" },
      ];
    },
    keyword() {
      if (this.$route.query.keyword) {
        return this.$route.query.keyword;
      } else {
        return "";
      }
    },
  },

  methods: {
    // getCompanies() {
    //   this.$axios.get("rentals_without_pagination").then((res) => {
    //     console.log(res.data);
    //     this.companies = res.data.data.map((el) => {
    //       return { text: el.ar.title, value: el.id };
    //     });
    //   });
    // },
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },
    changeStatus(currStatus, id) {
      console.log(currStatus);
      this.btnIsLoading = true;
      let submit_data = new FormData();

      submit_data.append("status", currStatus);
      this.$axios({
        method: "POST",
        url: `orders/${id}/change-status`,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    assginDriver(driverID, orderID) {
      this.btnIsLoading = true;
      this.$axios({
        method: "POST",
        url: `orders/${orderID}/driver/${driverID}`,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    removeAssginedDriver(driverID, orderID) {
      this.btnIsLoading = true;
      this.$axios({
        method: "POST",
        url: `orders/${orderID}/driver/${driverID}/remove-assign`,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    show_model_1(e) {
      this.model_1.model_img_src = e;
      this.model_1.show_model = true;
    },
    orderStatusList(status, with_driver) {
      if (status == "pending" || status == "booked") {
        return [
          {
            text: "قبول",
            value: "company_accept",
          },
          { text: "رفض", value: "company_reject" },
        ];
      } else if (status == "payed" && !with_driver) {
        return [{ text: "تنفيذ الطلب", value: "company_start" }];
      } else if (status == "payed" && with_driver) {
        return [{ text: "إرسال السائق", value: "driver_in_the_way" }];
      } else if (status == "driver_in_the_way") {
        return [{ text: "بدء الطلب", value: "company_start" }];
      } else if (status == "company_start") {
        return [{ text: "انهاء الطلب", value: "company_finished" }];
      }
    },
    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/orders/add" });
    },
    // Show Car
    showItem(item) {
      this.$router.push({ path: "/package_order/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/orders/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `order/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      //   if (e) {
      //     this.paginations.current_page = 1;
      //     this.$router.replace({ query: { page: 1 } });
      //   }
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "package_order",
        params: {
          page: this.paginations.current_page,
          per_page: this.paginations.items_per_page,
          driver_id: this.userInfo?.id,
          status: this.$route.query.status ? this.$route.query.status : "",
          // from_date: e?.dateStart ? e.dateStart : "",
          // to_date: e?.dateEnd ? e.dateEnd : "",
        },
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router.replace({ query: { page: e } });
      this.setRows();
    },
    onPerPageChange() {
      this.paginations.current_page = 1;
      this.setRows();
    },
  },
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    // this.getCompanies();
    // if (this.userInfo && this.userInfo?.id) {
    //   this.setRows();
    // }
    // this.$globalService.getDrivers().then((res) => (this.drivers = res));
  },
  mounted() {
    if (this.userInfo && this.userInfo?.id) {
      this.setRows();
    }
  },

  // ======= hooks
};
</script>

<style lang="scss">
.v-text-field__details {
  display: none !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
</style>
